module.exports = __webpack_public_path__ + "static/img/weatherroute3.7c43db9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/weatherroute3.png
// module id = JzXQ
// module chunks = 0